import React from "react";
import ChartistPointLabel from 'chartist-plugin-pointlabels';
import { updateViewBox } from "../utils/UpdateViebox";
import { localizeValue } from "../utils/Labels";
import ChartistGraph from "../ChartistGraph/ChartistGraph";
import Tooltip from "@bge/chartist_custom_plugins/dist/es/tooltip/chartist-plugin-tooltip-custom";

const SeriesValueChart = (props) => {
  const { labels = [], series = [], chartClassName = "ct-double-octave", options = {}, locale } = props;
  let chartSeries = [];

  const reverse = options.reverseData;
  
  for (let i = 0; i < series.length; i++) {
    let chartSerie = [];
    for (let j = 0; j < series[i].length; j++) {
      let labelPos = j;
      if (reverse) labelPos = labels.length-j-1;
      chartSerie.push({meta: labels[labelPos], value:series[i][j]});
    }
    chartSeries.push(chartSerie);
  }

  const data = {
    labels: labels,
    series: chartSeries
  };

  const chartOptions = {
    showArea: true,
    // fullWidth: true,
    axisX: {
      position: 'end',
      showGrid: true,
      offset: 20
    },
    axisY: {
      // On the y-axis start means left and end means right
      showGrid: true,
      showLabel: false,
      offset: 0
      // labelInterpolationFnc: value => `${value / 1}k`
    },
    ...options
  };
  const listener = {
    created: function (data) {
      updateViewBox(data);
    },
    draw: function (data) {
    }
  }

  const {prefix = "", suffix = ""} = options;

  let labelTransformFn = null;
  if(options.transform)
    labelTransformFn = options.transform.labels;

  const plugins = [
    Tooltip({
      appendToBody: true, 
      appendToPoint: true,
      tooltipFnc: (meta, value) => `${meta} <br> <p class="value-text">${prefix}${value}${suffix}</p>`,
      transformTooltipTextFnc: (value) => labelTransformFn ? labelTransformFn(value, locale) :  localizeValue(value, locale)
    }),
    ChartistPointLabel({
      textAnchor: 'middle',
      labelInterpolationFnc:(value) => `${prefix}${labelTransformFn ? labelTransformFn(value, locale) :  localizeValue(value, locale)}${suffix}`
    })
  ]

  return (
    <ChartistGraph
      data={data}
      options={{...chartOptions, plugins}}
      type="Line"
      className={"series-value-chart " + chartClassName}
      listener={listener}
    />
  );
};

export default SeriesValueChart;